<template>
   <v-card class="detail-card">
      <v-card-title>
        <h3>{{displayTitle}}</h3>
      </v-card-title>
    <v-card-text>
    <v-data-table
      :headers="headers"
      :items="metalLoadData"
      hide-actions
      class="elevation-1"
      item-key="id"
    >
      <template v-slot:items="props">
        <td>Carga De Metal</td>
        <td class="text-xs-right" v-if="props.item">{{props.item.platinum | currency('', 8)}}</td>
        <td class="text-xs-right" v-if="props.item">{{props.item.palladium | currency('', 8)}}</td>
        <td class="text-xs-right" v-if="props.item">{{props.item.rhodium | currency('', 8)}}</td>
      </template>
    </v-data-table>
  </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ['detail', 'title'],
  data() {
    return {
      headers: [
        {text: '', sortable: false},
        {text: 'Platino', sortable: false},
        {text: 'Paladio', sortable: false},
        {text: 'Rodio', sortable: false},
      ],
    };
  },
  computed: {
    displayTitle() {
      if (!this.title) {
        return 'Carga de Metal de la Ruta en este saco';
      } else {
        return this.title;
      }
    },
    metalLoadData() {
      if (this.detail) {
        const result = [this.detail.catalyst];
        return result;
      }
      return [];
    },
  },
};
</script>
